/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
export const StatusTypeFormatter = (cellContent, row, rowIndex) => {
  const renderStatus = (status) => {
    let statusClass = "";
    statusClass = status ? "status-success" : "status-rejected";
    return (
      <span className={`${statusClass} status-color text-capitalize`}>
        {status ? "Active" : "Deactive"}
      </span>
    );
  };

  return (
    <span className="text-dark-75 d-block">{renderStatus(row.status)}</span>
  );
};
